import { StudyType } from '@/shared/api/protocol-ts/model/dto_study_pb';

export const STUDY_TYPE_TO_LABEL: Record<string, string> = {
  [StudyType.StudyType_CBCT.toString()]: 'cbct',
  [StudyType.StudyType_IntraoralXRay.toString()]: 'ioxray',
  [StudyType.StudyType_PanoramicXRay.toString()]: 'pano',
  [StudyType.StudyType_IOS_Meshes.toString()]: 'ios',
  [StudyType.StudyType_DentalPhoto.toString()]: 'dental_photo',
};
